import { render, staticRenderFns } from "./FPTemp6.vue?vue&type=template&id=0fd23e22&scoped=true&"
import script from "./FPTemp6.vue?vue&type=script&lang=js&"
export * from "./FPTemp6.vue?vue&type=script&lang=js&"
import style0 from "./FPTemp6.vue?vue&type=style&index=0&id=0fd23e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd23e22",
  null
  
)

export default component.exports